// extracted by mini-css-extract-plugin
module.exports = {"accepted":"ConsentStatus_accepted__yMghl","declined":"ConsentStatus_declined__2wwMo","withdrawn":"ConsentStatus_withdrawn__2HNRN"};